export const ANONYMOUS_USERS_CRITERIA_FEATURE_FLAG = 'AnonymousUserCriteria';
export const EMBEDDED_MESSAGING_CORE_FEATURE_FLAG = 'EmbeddedMessagingCore';
export const WHATS_APP_EVENTS_FEATURE_FLAG = 'WhatsAppMessageChannel';
export const WHATS_APP_EVENTS_GA_FEATURE_FLAG = 'WhatsAppMessageChannelGA';
export const JOURNEY_EXIT_EVENTS_FEATURE_FLAG = 'JourneyExitEvents';
export const UNSUBSCRIBED_MESSAGE_TYPE_REPLACEMENT_FEATURE_FLAG =
  'UnsubscribeMessageTypeReplacement';
